import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatStepperModule } from '@angular/material/stepper';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatNativeDateModule } from '@angular/material/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { PinchZoomModule } from 'ngx-pinch-zoom';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { ConsultationStatusPipe } from './pipes/consultation-status.pipe';

import { ConfirmationDialogBoxComponent } from './components/confirmation-dialog-box/confirmation-dialog-box.component';
import { PaymentRequestStatusPipe } from './pipes/payment-request-status.pipe';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { PrimaryLayoutComponent } from './components/layouts/primary-layout/primary-layout.component';

const sharedModules = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  MatStepperModule,
  MatInputModule,
  MatButtonModule,
  MatListModule,
  MatIconModule,
  MatDatepickerModule,
  MatRadioModule,
  MatFormFieldModule,
  MatNativeDateModule,
  MatProgressSpinnerModule,
  MatToolbarModule,
  MatSelectModule,
  MatSnackBarModule,
  MatCardModule,
  FontAwesomeModule,
  MatButtonToggleModule,
  PinchZoomModule,
  MatDialogModule,
  MatSidenavModule,
  MatCheckboxModule,
];
const sharedPipes = [ConsultationStatusPipe, PaymentRequestStatusPipe];
const declarations = [
  PrimaryLayoutComponent,
  ConfirmationDialogBoxComponent,
  NotFoundComponent,
];

@NgModule({
  declarations: [...declarations, ...sharedPipes],
  providers: [...sharedPipes],
  imports: [...sharedModules],
  exports: [...sharedModules, ...declarations, ...sharedPipes],
})
export class SharedModule {}
